<h1 mat-dialog-title>EBB Retrofit Project</h1>
<div mat-dialog-content>
  <div *ngIf="data else showRejectionMessage">
    <h6>Congratulations!</h6>
    <p>
      You just accepted a new Seismic Retrofit Project.
    </p>
    
    <p>
      Please <a routerLink="/contact">contact us</a> if you have any questions.
    </p>
  </div>
  <ng-template #showRejectionMessage>
    <p>
      You have declined this Seismic Retrofit Project.
    </p>
    <p>
      Please <a routerLink="/contact">contact us</a> if you have any questions.
    </p>
  </ng-template>

</div>
<div mat-dialog-actions style="margin-top: 9px !important; float: right !important;">
  <button mat-button 
    (click)="onClickCancel()">
    CANCEL
  </button>
  <button mat-flat-button color="primary" style="margin-left: 6px;"
    (click)="onClickConfirm()">
    CONFIRM
  </button>
</div>
